export default {
  // Page title
  'page.title': 'Cronómetro',

  // How to use
  'howto.title': 'Cómo Usar',
  'howto.step1': 'Haz clic en el botón "Iniciar" para comenzar el cronómetro, formato de visualización: minutos:segundos.centésimas de segundo',
  'howto.step2': 'Haz clic en "Pausar" para pausar el cronometraje cuando el cronómetro esté en funcionamiento, haz clic en "Iniciar" nuevamente para continuar',
  'howto.step3': 'Haz clic en el botón "Reiniciar" para restablecer el cronómetro a cero y detener el cronometraje',
  'howto.step4': 'El cronómetro admite visualización de precisión de milisegundos, adecuado para escenarios que requieren cronometraje preciso',

  // User reviews
  'reviews.title': 'Opiniones de Usuarios',
  'reviews.michaelRunner': '¡Herramienta de entrenamiento esencial! La precisión de milisegundos me permite registrar con exactitud cada rendimiento de sprint, operación simple y rápida.',
  'reviews.chefJohnson': '¡Magia del temporizador de cocina! Saltear, hervir fideos, cocer huevos al vapor, todo necesita cronometraje preciso, este cronómetro me ayuda a preparar platos perfectos.',
  'reviews.sarahStudent': '¡Esencial para simulación de exámenes! Lo uso para practicar el tiempo de respuesta, la interfaz limpia no distrae la atención, mejoró la eficiencia de respuesta.',
  'reviews.coachWilliams': '¡Gran asistente para cursos de entrenamiento! El entrenamiento por intervalos y las planchas necesitan cronometraje preciso, a los estudiantes les encanta.',
  'reviews.drAnderson': 'El trabajo médico a menudo requiere cronometraje preciso, este cronómetro es simple y confiable, un gran asistente para mi trabajo clínico.',

  // User names
  'user.michaelRunner': 'Michael Corredor',
  'user.chefJohnson': 'Chef Johnson',
  'user.sarahStudent': 'Sarah Estudiante',
  'user.coachWilliams': 'Entrenador Williams',
  'user.drAnderson': 'Dr. Anderson',

  // Keywords section
  'keywords.stopwatch': 'cronómetro temporizador cronometraje preciso qué hora es',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};